export default {
order_history: "سجل الطلبات",
all_status: "كل الحالات",
placed: "تم الطلب",
accepted: "تم القبول",
packed: "تم التغليف",
delivered: "تم التسليم",
rejected: "مرفوض",

all_payments: "كل المدفوعات",
paid: "مدفوع",
unpaid: "غير مدفوع",
payment_partial: "دفع جزئي",

all_amounts: "كل المبالغ",
search_orders: "ابحث برقم الطلب أو المطعم...",

order_id: "رقم الطلب",
restaurant: "المطعم",
date: "التاريخ",
total: "الإجمالي",
status: "الحالة",
payment_type: "نوع الدفع",
payment: "الدفع",
action: "الإجراء",

view: "عرض",
chat: "دردشة",
no_orders: "لا توجد طلبات",

// STATUS KEYS
status_placed: "تم الطلب",
status_accepted: "تم القبول",
status_packed: "تم التغليف",
status_out_for_delivery: "قيد التوصيل",
status_delivered: "تم التسليم",
status_rejected: "مرفوض",

method_cod: "الدفع عند الاستلام",
method_online: "دفع إلكتروني",
method_credit: "ائتمان",

payment_paid: "مدفوع",
payment_pending: "قيد الانتظار",
payment_unpaid: "غير مدفوع",

currency_code: "ر.ق",
price_0_100: "٠ – ١٠٠ ر.ق",
price_100_500: "١٠٠ – ٥٠٠ ر.ق",
price_500_1000: "٥٠٠ – ١٠٠٠ ر.ق",
price_1000_5000: "١٠٠٠ – ٥٠٠٠ ر.ق",
price_5000_plus: "٥٠٠٠+ ر.ق",
recurring: "متكرر",
order_details: "تفاصيل الطلب",
order_modification: "تعديل الطلب",
recurring: "متكرر",
recurring_details: "تفاصيل الطلب المتكرر",
frequency: "التكرار",
next_run: "التشغيل التالي",
start_date: "تاريخ البدء",
end_date: "تاريخ الانتهاء",
skip_today: "تخطي اليوم",

restaurant_details: "تفاصيل المطعم",
name: "الاسم",
supbranch: "الفرع",
contact: "جهة الاتصال",
mobile: "رقم الجوال",
email: "البريد الإلكتروني",
supaddress: "العنوان",

products: "المنتجات",
product: "المنتج",
qty: "الكمية",
price: "السعر",
total: "الإجمالي",
unit_price: "سعر الوحدة",
remove: "حذف",

modification_reason: "سبب التعديل",
send_modification: "إرسال طلب التعديل",

order_timeline: "تتبع الطلب",

accept: "قبول",
reject: "رفض",
mark_packed: "تم التغليف",
view_delivery: "عرض حالة التوصيل",
generate_invoice: "إنشاء فاتورة",
view_receipt: "عرض الإيصال",
assign_delivery: "تعيين مندوب",
modify_order: "تعديل الطلب",
}